import { IndianRupee } from "lucide-react";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

export interface PriceRow { item: string; range: string; notes?: string; }

interface Props { rows: PriceRow[]; title?: string; }

const PricingTable = ({ rows, title = "Indicative Pricing" }: Props) => (
  <section className="py-14 md:py-20 bg-muted/40">
    <div className="container max-w-4xl">
      <div className="text-center mb-8">
        <span className="text-eyebrow text-primary">Transparent Pricing</span>
        <h2 className="font-heading text-2xl md:text-3xl font-light mt-2">{title} in Kalyan</h2>
      </div>
      <div className="bg-card rounded-xl border border-border overflow-hidden shadow-sm">
        <Table>
          <TableHeader>
            <TableRow className="bg-secondary/40">
              <TableHead className="font-heading">Treatment</TableHead>
              <TableHead className="font-heading">Price Range (₹)</TableHead>
              <TableHead className="font-heading hidden md:table-cell">Notes</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.item}>
                <TableCell className="font-medium">{r.item}</TableCell>
                <TableCell className="font-heading text-primary inline-flex items-center gap-1"><IndianRupee className="h-3.5 w-3.5" />{r.range}</TableCell>
                <TableCell className="text-sm text-muted-foreground hidden md:table-cell">{r.notes || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <p className="text-xs md:text-sm text-muted-foreground text-center mt-4 italic">
        Indicative ranges only. Final cost depends on case complexity, materials chosen and number of sittings.
        Book a free consultation for a written quote.
      </p>
    </div>
  </section>
);

export default PricingTable;